// This is a directive which wraps another and uses transclusion to either display the contents or N/A if the expression
// evaluates to true.
//
// For example, $scope.dontShowNumber will control whether we see N/A or $scope.someNumber here:
//   <div n-a="dontShowNumber">{{ someNumber }}</div>
export default function NaDirective() {
  return {
    restrict: 'A',
    scope: {
      nA: '='
    },
    transclude: true,
    template:
      '<span ng-if="nA">N/A</span><span ng-show="!nA" ng-transclude></span>'
  };
}
